// Seed the per-item "year" selects of an Add*ReviewDialog from a
// { [id]: year } map carried over from a prior review (or a programme
// transfer). Only ticked items are seeded, and only when a truthy year is
// present — an absent year leaves the field on its current-year default.
export const applyYearPrefill = ({ form, items, selectedIds, yearById }) => {
  if (!selectedIds?.length || !yearById) return;

  items.forEach((item) => {
    if (!selectedIds.includes(item.id)) return;

    const year = yearById[item.id];

    if (year) form.setValue(`${item.field}Year`, year.toString());
  });
};

// The PP registration form stores a SINGLE shared year of registration, so a
// per-reason transferred year map must be reduced to one value. Deterministic
// rule: the first available (truthy) year following the order of the carried
// reason codes. Returns null when none is available (current-year default).
export const firstAvailableYear = ({ selectedIds, yearById }) => {
  if (!selectedIds?.length || !yearById) return null;

  for (const id of selectedIds) {
    const year = yearById[id];

    if (year) return year.toString();
  }

  return null;
};
